import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const StarHalfFilledIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  const aspectRatio = 17 / 16;
  const width = Number(size) * aspectRatio;
  return __jsx("svg", _extends({
    width: width,
    height: size,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M5.41515 5.11885L7.59927 0.792305C7.69736 0.597985 7.87904 0.500551 8.06096 0.500002C8.2439 0.499451 8.42708 0.596887 8.52573 0.792307L10.7099 5.11885L15.6083 5.81472C15.8755 5.85267 16.0433 6.0781 16.061 6.31968C16.063 6.34769 16.063 6.37593 16.061 6.40411C16.0514 6.53408 15.9972 6.66299 15.8905 6.76462L12.3682 10.1213L13.1979 14.8508C13.2757 15.2942 12.8382 15.6413 12.4517 15.4427L8.0625 13.1868L3.67327 15.4427C3.62497 15.4675 3.57587 15.4838 3.52707 15.4925C3.1855 15.5531 2.85899 15.2388 2.92707 14.8508L3.75679 10.1213L0.234463 6.76462C0.116165 6.65189 0.0623864 6.50559 0.0625002 6.36151C0.0625843 6.25501 0.0921114 6.14972 0.14679 6.06009C0.223982 5.93355 0.351301 5.83821 0.516672 5.81472L5.41515 5.11885ZM8.06096 12.0265C8.14049 12.0263 8.22006 12.045 8.29333 12.0826L11.9791 13.977L11.2848 10.0197C11.2521 9.83316 11.3136 9.64214 11.4476 9.5145L14.3544 6.7444L10.3021 6.16874C10.1346 6.14494 9.98832 6.03795 9.9093 5.88141L8.0625 2.22308L8.06096 2.22614V12.0265Z",
    fill: color
  }));
};
export default StarHalfFilledIcon;